import { HotelProfileState } from "@/AppRedux/actions/hotelProfile/hotelType";
import { RootState } from "@/AppRedux/reducers"
import { useSelector } from "react-redux"

const HotelProfileStateHook = () => {
  const hotelProfileState:HotelProfileState = useSelector((state: RootState) => state.hotelProfile)
  const {
    dataSource,
    loading,
    process
  } = hotelProfileState

  return {
    dataSource,
    loading,
    process
  }
}
export default HotelProfileStateHook